export default "__VITE_ASSET__DrLPja7V__"